import React from 'react';
import { Link } from 'react-router-dom';
import { useShoppingCart } from '../context/ShoppingCartContext';
import { FaTrash } from 'react-icons/fa';

export default function CartPage() {
  const { cart, removeFromCart, updateQuantity, getCartTotal, getCartCount } = useShoppingCart();
  
  if (cart.length === 0) {
    return (
      <div className="container" style={{ textAlign: 'center', padding: '60px 20px' }}>
        <h2>Shporta është e zbrazët</h2>
        <p>Shtoni disa produkte për të vazhduar blerjen.</p>
        <Link to="/" className="btn btn-primary" style={{ display: 'inline-block', marginTop: '20px', padding: '12px 24px', background: '#27ae60', color: 'white', textDecoration: 'none', borderRadius: '4px' }}>
          Vazhdo blerjet
        </Link>
      </div>
    );
  }

  return (
    <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ marginBottom: '20px', fontSize: '24px' }}>Shporta ({getCartCount()} artikuj)</h1>
      
      {/* Layout - në desktop 2 kolona, në mobile 1 kolonë */}
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        gap: '30px'
      }}>
        {/* Lista e produkteve - zë gjithë gjerësinë */}
        <div style={{ width: '100%' }}>
          {cart.map(item => (
            <div key={item._id} style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '15px',
              padding: '15px',
              borderBottom: '1px solid #eee',
              marginBottom: '10px',
              alignItems: 'center'
            }}>
              {/* Foto */}
              <img 
                src={item.image || 'https://placehold.co/80x80/2c3e50/white?text=No+Image'} 
                alt={item.name}
                style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '4px' }}
              />
              
              {/* Detajet */}
              <div style={{ flex: '1', minWidth: '150px' }}>
                <h3 style={{ margin: '0 0 5px 0', fontSize: '16px' }}>{item.name}</h3>
                <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>{item.category}</p>
                <p style={{ margin: '5px 0 0 0', fontWeight: 'bold', color: '#27ae60' }}>
                  €{item.price?.toFixed(2)}
                </p>
              </div>
              
              {/* Sasia dhe totali */}
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '15px',
                flexWrap: 'wrap',
                marginTop: '5px'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '14px' }}>Sasia:</span>
                  <input
                    type="number"
                    min="1"
                    value={item.quantity || 1}
                    onChange={(e) => updateQuantity(item._id, parseInt(e.target.value))}
                    style={{ width: '60px', padding: '5px', textAlign: 'center', borderRadius: '4px', border: '1px solid #ddd' }}
                  />
                </div>
                
                <div style={{ fontWeight: 'bold', minWidth: '80px', textAlign: 'right' }}>
                  €{((item.price || 0) * (item.quantity || 1)).toFixed(2)}
                </div>
                
                <button
                  onClick={() => removeFromCart(item._id)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#e74c3c',
                    cursor: 'pointer',
                    fontSize: '16px',
                    padding: '5px'
                  }}
                >
                  <FaTrash />
                </button>
              </div>
            </div>
          ))}
        </div>
        
        {/* Përmbledhja - në fund, gjithmonë e plotë */}
        <div style={{
          background: '#f8f9fa',
          padding: '20px',
          borderRadius: '8px',
          width: '100%',
          maxWidth: '400px',
          margin: '0 auto'
        }}>
          <h3 style={{ marginTop: 0, fontSize: '18px' }}>Përmbledhja</h3>
          
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
            <span>Nëntotali:</span>
            <span>€{getCartTotal().toFixed(2)}</span>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', color: '#666' }}>
            <span>Transporti:</span>
            <span>Falas</span>
          </div>
          
          <div style={{ borderTop: '1px solid #ddd', marginTop: '10px', paddingTop: '10px', display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '18px' }}>
            <span>Totali:</span>
            <span>€{getCartTotal().toFixed(2)}</span>
          </div>
          
          <Link
            to="/checkout"
            style={{
              display: 'block',
              background: '#27ae60',
              color: 'white',
              textAlign: 'center',
              padding: '12px',
              borderRadius: '4px',
              textDecoration: 'none',
              marginTop: '20px',
              fontWeight: 'bold',
              fontSize: '16px'
            }}
          >
            Vazhdo te porosia
          </Link>
        </div>
      </div>
    </div>
  );
}